import { createFileRoute } from "@tanstack/react-router";
import { SubscriptionSuccess } from "@/lib/lazyPages";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/subscription/success-report")({
  head: () => seoHead({
    title: "Report Unlocked",
    description: "Your LeadXkids assessment report is unlocked.",
    noindex: true,
  }),
  component: () => <SubscriptionSuccess variant="report" />,
});
